import {
    STATISTICS_CALENDAR_SUCCESS
} from './constants';

const initialStatisticsCalendarState = {};

/**
 *
 * @param state
 * @param action
 */
const statisticsCalendarReducer = (state = initialStatisticsCalendarState, action) => {
    switch (action.type) {
        case STATISTICS_CALENDAR_SUCCESS: {
            return { ...action.statistics };
        }
        default:
            return state;
    }
};

export { statisticsCalendarReducer as calendarstats };